export function LoadingState({ label = 'Loading operational data' }: { label?: string }) {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <span className="loading-rule" />
      <span>{label}</span>
    </div>
  )
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="error-state" role="alert">
      <strong>Data could not be loaded</strong>
      <span>{message} Refresh the page or choose another reporting period.</span>
    </div>
  )
}

export function EmptyState() {
  return (
    <div className="empty-state">
      <strong>No weighing data in this period</strong>
      <span>Choose another reporting period. Current connection status is shown separately.</span>
    </div>
  )
}
